import { lazy, Suspense, useEffect, useState } from 'react'
import { useBennyStore } from '@/store/benny.store'
import { useLocation } from 'react-router-dom'

import { useBennyAvailable } from './useBennyAvailable'
import { useOpenBenny } from './useOpenBenny'

const BennyChat = lazy(() =>
  import('./BennyChat').then(module => ({ default: module.BennyChat })),
)

/** Keep the global shortcut cheap; retain the chat after first use so drafts survive closing. */
export function BennyChatLauncher() {
  const open = useBennyStore(state => state.open)
  const available = useBennyAvailable()
  const { pathname } = useLocation()
  const canOpen = available || /(^|\/)help(\/|$)/.test(pathname)
  const openBenny = useOpenBenny()
  const [hasOpened, setHasOpened] = useState(open)
  useEffect(() => {
    if (open) setHasOpened(true)
  }, [open])
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!(event.metaKey || event.ctrlKey) || event.key !== '.' || !canOpen)
        return
      event.preventDefault()
      if (useBennyStore.getState().open) useBennyStore.getState().setOpen(false)
      else void openBenny()
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [canOpen, openBenny])
  if (!open && !hasOpened) return null
  return (
    <Suspense
      fallback={
        open ? (
          <div
            role="status"
            className="rounded-card fixed bottom-4 right-4 border bg-background p-4 text-sm"
          >
            Opening Benny…
          </div>
        ) : null
      }
    >
      <BennyChat />
    </Suspense>
  )
}
